import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import TasksList from './TasksList/TasksList';
import TaskEdit from './TaskEdit/TaskEdit';
import TaskCreate from './TaskCreate/TaskCreate';
import TaskDelete from './TaskDelete/TaskDelete';

const Tasks = ({ match }) => {
    return (
        <div className="Tasks">
            <ContainerWrapper container="tasks">
                <Route exact path={ match.path } component={TasksList} />
                <Route exact path={ `${ match.url }/new/:screening_id?` } component={TaskCreate} />
                <Route exact path={ `${ match.url }/edit/:taskId` } component={TaskEdit} />
                <Route exact path={ `${ match.url }/delete/:taskId` } component={TaskDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Tasks;
